module.exports = __webpack_public_path__ + "static/media/menu-contrast.a5e89630.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/menu-contrast.svg
// module id = 798
// module chunks = 0